import { uniqueId } from "lodash";
import AuthorizedPage from "~/detect_devices/AuthorizedPage";
import BookingDetailForCSKH from "~/detect_devices/BookingDetailForCSKH";
import BookingDetailForUser from "~/detect_devices/BookingDetailForUser";
import BookingPatientUpdateLoader from "~/detect_devices/BookingPatientUpdate";
import CheckBHYTLoader from "~/detect_devices/CheckBHYT";
import CheckPatientBeforeCreate from "~/detect_devices/CheckPatientBeforeCreate";
import ChooseFeatureBookingLoader from "~/detect_devices/ChooseFeatureBooking";
import ChooseHospitalLoader from "~/detect_devices/ChooseHospital";
import ChoosePatientLoader from "~/detect_devices/ChoosePatient";
import ContactLoader from "~/detect_devices/Contact";
import CustomerServiceLoader from "~/detect_devices/CustomerService";
import Demo from "~/detect_devices/demo";
import Download from "~/detect_devices/Download";
import ElectricInvoicesResultSearchLoader from "~/detect_devices/ElectricInvoicesResultSearch";
import ElectronicInvoicesSearchLoader from "~/detect_devices/ElectronicInvoicesSearch";
import FaqDetailLoader from "~/detect_devices/FaqDetail";
import FaqDetailAppLoader from "~/detect_devices/FaqDetailApp";
import FeeResultSearchLoader from "~/detect_devices/FeeResultSearch";
import FeeSearchLoader from "~/detect_devices/FeeSearch";
import FindBHYTLoader from "~/detect_devices/FindBHYTByScanQrCode";
import FollowUpExamLoader from "~/detect_devices/FollowUpExam";
import FollowUpExamGetInfoByPhone from "~/detect_devices/FollowUpExamGetInfoByPhone";
import HistoryPaymentLoader from "~/detect_devices/HistoryPayment";
import HomePageLoader from "~/detect_devices/Home";
import InstructionBHYT from "~/detect_devices/InstructionBHYT";
import InstructionBHYTApp from "~/detect_devices/InstructionBHYTApp";
import InstructionIncorrectBHYT from "~/detect_devices/InstructionIncorrectBHYT";
import InstructionIncorrectBHYTApp from "~/detect_devices/InstructionInCorrectBHYTApp";
import InstructionInCorrectBHYTAppDaLieuHCM from "~/detect_devices/InstructionInCorrectBHYTAppDaLieuHCM";
import InstructionIncorrectBHYTDalieuhcm from "~/detect_devices/InstructionIncorrectBHYTDalieuhcm";
import IntroduceLoader from "~/detect_devices/Introduce";
import MedicalBillLoader from "~/detect_devices/MedicalBill";
import MedicalBillListLoader from "~/detect_devices/MedicalBillList";
import MomoWaitingRedirect from "~/detect_devices/MomoRedirect";
import NotificationLoader from "~/detect_devices/Notification";
import NotificationDetailLoader from "~/detect_devices/NotificationDetail";
import PatientCheckPhoneLoader from "~/detect_devices/PatientCheckPhone";
import PatientCreateLoader from "~/detect_devices/PatientCreate";
import PatientForgotCodeLoader from "~/detect_devices/PatientForgotCode";
import PatientRecordsLoader from "~/detect_devices/PatientRecords";
import PatientRecordsDetailLoader from "~/detect_devices/PatientRecordsDetail";
import PatientResultSearchLoader from "~/detect_devices/PatientResultSearch";
import PatientUpdateLoader from "~/detect_devices/PatientUpdate";
import PatientVerifyInfomationLoader from "~/detect_devices/PatientVerifyInfomation";
import PaymentApp from "~/detect_devices/PaymentApp";
import PaymentAppSuccess from "~/detect_devices/PaymentAppSuccess";
import PaymentExamWithQrCode from "~/detect_devices/PaymentExamWithQrCode";
import PaymentFeeMethodLoader from "~/detect_devices/PaymentFeeMethod";
import PaymentFeeResultLoader from "~/detect_devices/PaymentFeeResult";
import PaymentMethodLoader from "~/detect_devices/PaymentMethod";
import PaymentWithQrCode from "~/detect_devices/PaymentWithQrCode";
import PrivacyPolicyLoader from "~/detect_devices/PrivacyPolicy";
import PrivacyPolicyAppLoader from "~/detect_devices/PrivacyPolicyApp";
import ProcedureLoader from "~/detect_devices/Procedure";
import ChooseCalendarLoader from "~/detect_devices/Schedules/ChooseCalendar";
import ChooseDoctorLoader from "~/detect_devices/Schedules/ChooseDoctor";
import ChooseRoomLoader from "~/detect_devices/Schedules/ChooseRoom";
import ChooseServiceLoader from "~/detect_devices/Schedules/ChooseService";
import ChooseSubjectLoader from "~/detect_devices/Schedules/ChooseSpecialty";
import SearchReExamination from "~/detect_devices/SearchReExamination";
import TermsOfServiceLoader from "~/detect_devices/TermsOfService";
import TermsOfServiceAppLoader from "~/detect_devices/TermsOfServiceApp";
import TransferInformationLoader from "~/detect_devices/TransferInformation";
import TrustInformationLoader from "~/detect_devices/TrustInformation";
import UsageRulesLoader from "~/detect_devices/UsageRules";
import UsageRulesAppLoader from "~/detect_devices/UsageRulesApp";
import UserLoader from "~/detect_devices/User";
import LoginLoader from "~/detect_devices/Login";
import ManagePaymentMethodPage from "~/detect_devices/ManagePaymentMethod";

// list route dynamic
const listRouteDynamic = [
  {
    id: "chon-hinh-thuc-dat-kham",
    path: "/chon-hinh-thuc-dat-kham",
    component: ChooseFeatureBookingLoader,
    authorized: false,
    breadcrumb: true,
    exact: false
  },
  {
    id: "chon-dich-vu",
    path: "/chon-dich-vu",
    component: ChooseServiceLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-bac-si",
    path: "/chon-bac-si",
    component: ChooseDoctorLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-chuyen-khoa",
    path: "/chon-chuyen-khoa",
    component: ChooseSubjectLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-phong-kham",
    path: "/chon-phong-kham",
    component: ChooseRoomLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "chon-lich-kham",
    path: "/chon-lich-kham",
    component: ChooseCalendarLoader,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "xac-nhan-thong-tin",
    path: "/xac-nhan-thong-tin",
    component: TrustInformationLoader,
    authorized: true,
    breadcrumb: true,
    exact: true
  },
  {
    id: "hinh-thuc-thanh-toan",
    path: "/hinh-thuc-thanh-toan",
    component: PaymentMethodLoader,
    authorized: false,
    breadcrumb: true,
    exact: false
  },
  {
    id: "huong-dan-bao-hiem-y-te-dung-tuyen",
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen",
    component: InstructionBHYT,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "huong-dan-bao-hiem-y-te-trai-tuyen",
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen",
    component: InstructionIncorrectBHYT,
    authorized: false,
    breadcrumb: true,
    exact: true
  },
  {
    id: "huong-dan-bao-hiem-y-te-trai-tuyen-dalieuhcm",
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-dalieuhcm",
    component: InstructionIncorrectBHYTDalieuhcm,
    authorized: false,
    childDynamic: null,
    breadcrumb: true,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-bvmathcm",
    component: InstructionIncorrectBHYTDalieuhcm,
    authorized: false,
    childDynamic: null,
    breadcrumb: true,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-bvmathcm/:id/:date",
    component: InstructionInCorrectBHYTAppDaLieuHCM,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: uniqueId(),
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-confirm-bvmathcm/:id/:date",
    component: InstructionInCorrectBHYTAppDaLieuHCM,
    authorized: false,
    childDynamic: null,
    exact: false
  }
];

// list route partner
// const listRoutePartner = getListParners().map(({ partnerId }) => {
//   return {
//     id: partnerId,
//     path: `/${partnerId}`,
//     childDynamic: listRouteDynamic.map(current => {
//       return {
//         ...current,
//         id: `${partnerId}-${current.id}`
//       };
//     })
//   };
// });

// list total route
const listRouters = [
  {
    id: 1,
    path: "/",
    component: HomePageLoader,
    authorized: true,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "login",
    path: "/login",
    component: LoginLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 2,
    path: "/chon-benh-vien",
    component: ChooseHospitalLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 8,
    path: "/chon-ho-so",
    component: ChoosePatientLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 13,
    path: "/quy-trinh",
    component: ProcedureLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 14,
    path: "/thac-mac",
    component: FaqDetailLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 15,
    path: "/thac-mac-app",
    component: FaqDetailAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 16,
    path: "/dieu-khoan-dich-vu",
    component: TermsOfServiceLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 17,
    path: "/dieu-khoan-dich-vu-app",
    component: TermsOfServiceAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 18,
    path: "/chinh-sach-bao-mat",
    component: PrivacyPolicyLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 19,
    path: "/chinh-sach-bao-mat-app",
    component: PrivacyPolicyAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 20,
    path: "/quy-dinh-su-dung",
    component: UsageRulesLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 21,
    path: "/quy-dinh-su-dung-app",
    component: UsageRulesAppLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 22,
    path: "/lien-he",
    component: ContactLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 23,
    path: "/gioi-thieu",
    component: IntroduceLoader,
    authorized: false,
    breadcrumb: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 26,
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen-app/:id",
    component: InstructionBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 261,
    path: "/huong-dan-bao-hiem-y-te-dung-tuyen-app-confirm/:id",
    component: InstructionBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 27,
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app/:id",
    component: InstructionIncorrectBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 271,
    path: "/huong-dan-bao-hiem-y-te-trai-tuyen-app-confirm/:id",
    component: InstructionIncorrectBHYTApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 28,
    path: "/authorized/:id",
    component: AuthorizedPage,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 29,
    path: "/user",
    component: UserLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 30,
    path: "/ho-so-benh-nhan",
    component: PatientRecordsLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 31,
    path: "/phieu-kham-benh",
    component: MedicalBillLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 32,
    path: "/lich-su-thanh-toan-vien-phi",
    component: HistoryPaymentLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 33,
    path: "/thong-bao",
    component: NotificationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 34,
    path: "/thong-bao/detail",
    component: NotificationDetailLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 35,
    path: "/ho-tro-thanh-toan",
    component: TransferInformationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 36,
    path: "/xac-thuc-dien-thoai-benh-nhan",
    component: PatientCheckPhoneLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 37,
    path: "/xac-nhan-thong-tin-benh-nhan",
    component: PatientVerifyInfomationLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 38,
    path: "/tim-lai-ma-benh-nhan",
    component: PatientForgotCodeLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 39,
    path: "/ket-qua-tim-benh-nhan",
    component: PatientResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 40,
    path: "/tao-moi-ho-so",
    component: PatientCreateLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 41,
    path: "/cap-nhat-thong-tin",
    component: PatientUpdateLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 42,
    path: "/chi-tiet-phieu-kham-benh",
    component: MedicalBillListLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },

  {
    id: 43,
    path: "/phieu-kham-benh/chi-tiet/:code",
    component: MedicalBillListLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 44,
    path: "/ho-so-benh-nhan/chi-tiet/:id",
    component: PatientRecordsDetailLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 45,
    path: "/reexam/:id",
    component: FollowUpExamLoader,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 46,
    path: "/tim-ma-thanh-toan-vien-phi",
    component: FeeSearchLoader,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: false
  },
  {
    id: 47,
    path: "/chi-tiet-ma-thanh-toan",
    component: FeeResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 481,
    path: "/hinh-thuc-thanh-toan-vien-phi",
    component: PaymentFeeMethodLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 482,
    path: "/quet-ma-qrcode-thanh-toan-vien-phi",
    component: PaymentWithQrCode,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 483,
    path: "/quet-ma-qrcode-thanh-toan-phieu-kham",
    component: PaymentExamWithQrCode,
    authorized: false,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 49,
    path: "/ket-qua-thanh-toan-vien-phi",
    component: PaymentFeeResultLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 50,
    path: "/chi-tiet-thanh-toan-vien-phi/:code",
    component: PaymentFeeResultLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 51,
    path: "/check-bhyt",
    component: CheckBHYTLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 52,
    path: "/find-bhyt",
    component: FindBHYTLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 53,
    path: "/check-patient-before-create",
    component: CheckPatientBeforeCreate,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 54,
    path: "/download",
    component: Download,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 55,
    path: "/getapp",
    component: Download,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 56,
    path: "/tra-cuu-hoa-don-dien-tu",
    component: ElectronicInvoicesSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 57,
    path: "/danh-sach-hoa-don-dien-tu",
    component: ElectricInvoicesResultSearchLoader,
    authorized: true,
    breadcrumb: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 58,
    path: "/id=:id",
    component: MomoWaitingRedirect,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh",
    path: "/cham-soc-khach-hang",
    component: CustomerServiceLoader,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/dspk",
    path: "/cham-soc-khach-hang/da-tung-kham",
    component: CustomerServiceLoader,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/qluser",
    path: "/cham-soc-khach-hang/tao-moi-ho-so-benh-nhan",
    component: CustomerServiceLoader,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/qledituser",
    path: "/cham-soc-khach-hang/cap-nhat-ho-so-benh-nhan",
    component: CustomerServiceLoader,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/examInfoByUser",
    path: "/booking/:smsCode",
    component: BookingDetailForUser,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "/share/:smsCode",
    path: "/share/:smsCode",
    component: BookingDetailForUser,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "/transactions/:transactions",
    path: "/transactions/:transactions",
    component: BookingDetailForUser,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/BookingDetailForCSKH",
    path: "/cskh/booking",
    component: BookingDetailForCSKH,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/BookingPatientUpdate",
    path: "/cskh/booking/cap-nhat-ho-so-benh-nhan",
    component: BookingPatientUpdateLoader,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: "user/BookingDetailForCSKH",
    path: "/user/booking",
    component: BookingDetailForCSKH,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "cskh/print/print",
    path: "/cskh/booking/in-phieu-kham-cskh",
    component: BookingDetailForCSKH,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 601,
    path: "/payment-app",
    component: PaymentApp,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 602,
    path: "/payment-app-success",
    component: PaymentAppSuccess,
    authorized: false,
    childDynamic: null,
    exact: false
  },
  {
    id: 451,
    path: "/reexam",
    component: FollowUpExamGetInfoByPhone,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 603,
    path: "/demo",
    component: Demo,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: 604,
    path: "/tim-kiem-thong-tin-tai-kham",
    component: SearchReExamination,
    authorized: true,
    childDynamic: null,
    exact: true
  },
  {
    id: 605,
    path: "/tat-ca-phuong-thuc-thanh-toan",
    component: ManagePaymentMethodPage,
    authorized: false,
    childDynamic: null,
    exact: true
  },
  {
    id: "partner_route",
    path: `/:partnerId`,
    childDynamic: listRouteDynamic.map(current => {
      return {
        ...current,
        id: `partner_route-${current.id}`
      };
    })
  }
];

export default listRouters;
